// assets/variant-media-sequence.js
(() => {
  const state = {
    product: null,
    fetching: null,
  };

  function getHandleFromUrl() {
    const m = window.location.pathname.match(/\/products\/([^\/]+)/);
    return m ? m[1] : null;
  }

  async function getProductJson() {
    if (state.product) return state.product;
    if (state.fetching) return state.fetching;

    const handle = getHandleFromUrl();
    if (!handle) return null;

    state.fetching = fetch(`/products/${handle}.js`, { credentials: "same-origin" })
      .then((r) => (r.ok ? r.json() : null))
      .then((json) => {
        state.product = json;
        return json;
      })
      .catch(() => null);

    return state.fetching;
  }

  function getCurrentVariantId() {
    const idInput = document.querySelector('form[action^="/cart/add"] input[name="id"]');
    const v = idInput && idInput.value ? Number(idInput.value) : null;
    return Number.isFinite(v) ? v : null;
  }

  function getGallery() {
    // Dawnの media-gallery 要素
    return document.querySelector("media-gallery");
  }

  function getSectionId(galleryEl) {
    // id="MediaGallery-{{ section.id }}"
    if (!galleryEl || !galleryEl.id) return null;
    const m = galleryEl.id.match(/^MediaGallery-(.+)$/);
    return m ? m[1] : null;
  }

  function hasSetActiveMedia(galleryEl) {
    return galleryEl && typeof galleryEl.setActiveMedia === "function";
  }

  async function moveToVariantFeaturedMedia() {
    const gallery = getGallery();
    if (!gallery || !hasSetActiveMedia(gallery)) return;

    const sectionId = getSectionId(gallery);
    if (!sectionId) return;

    const product = await getProductJson();
    if (!product || !Array.isArray(product.variants)) return;

    const variantId = getCurrentVariantId();
    if (!variantId) return;

    const variant = product.variants.find((v) => Number(v.id) === Number(variantId));
    if (!variant) return;

    // Shopify /products/xxx.js では variant.featured_media が入ることが多い
    const mediaId =
      (variant.featured_media && variant.featured_media.id) ||
      variant.featured_media ||
      null;

    if (!mediaId) return;

    // Dawnは "sectionId-mediaId" 形式で setActiveMedia を呼ぶ
    const targetKey = `${sectionId}-${mediaId}`;

    // 重要：DOMの並び替えは絶対にしない。移動だけ。
    gallery.setActiveMedia(targetKey, true);
  }

  function bind() {
    // option/select変更を広めに拾う（Dawn標準＋カスタムUI両対応）
    document.addEventListener("change", (e) => {
      const t = e.target;
      if (!t) return;

      // variant picker周辺をトリガーに
      if (
        t.name === "id" ||
        t.closest("variant-selects") ||
        t.closest("variant-radios") ||
        t.closest("[data-variant-picker]")
      ) {
        // Dawn側の更新が終わってから移動（1tick遅らせる）
        setTimeout(moveToVariantFeaturedMedia, 0);
      }
    });

    // 初期表示時も「選択中バリアントの先頭」に寄せたい場合
    window.addEventListener("load", () => {
      setTimeout(moveToVariantFeaturedMedia, 0);
    });
  }

  bind();
})();
